import axios from 'axios';
import { url } from '../env';

// Enviar cambios parciales del formulario para personaId
export async function savePreloanForm(personaId, data, stepKey, typePerson, { signal } = {}) {
    // Ajustar endpoint cuando el backend esté listo
    const endpoint = `${url}/savePreloanForm/${personaId}`;
    let token = localStorage.getItem("token");
    const response = await axios.post(endpoint, {data, stepKey, typePerson}, {
        signal,
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
    });
    return response.data;
}

// Obtener datos completos del precontrato para personaId
export async function fetchPreloanForm(personaId, typePerson, { signal } = {}) {
    const endpoint = `${url}/preloan/${personaId}/${typePerson}`;
    let token = localStorage.getItem("token");
    const response = await axios.get(endpoint, {
        signal,
        headers: { 'Accept': 'application/json', 'Authorization': `Bearer ${token}` }
    });
    return response.data;
}


